module.exports = "<template>\r\n\t<datepicker value.bind=\"value\" css=\"display: block; max-width: ${maxWidth}px\"></datepicker>\r\n</template>";